// extracted by mini-css-extract-plugin
export var body = "FilterCheckList-module--body--tr45F";
export var checked = "FilterCheckList-module--checked--ioaeT";
export var fieldset = "FilterCheckList-module--fieldset--vgvOy";
export var heading = "FilterCheckList-module--heading--gNUO-";